import ssc from './ssc';
import choose5 from './choose5';
import pk10 from './pk10';
import ks from './ks';
import hpten from './hpten';

export default (type, data, ballindex, Vue) => {
  if (type == 'ssc') {
    return ssc(data, ballindex);
  }
  if (type == 'choose5') {
    return choose5(data);
  }
  if (type == 'hpten') {
    return hpten(data);
  }
  if (type == 'PK10' || type == 'nn') {
    return pk10(data);
  }
  if (type == 'ks') {
    return ks(data, ballindex);
  }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/Haomatongji/columns/index.js